import script from "./quick-filter-species.vue?vue&type=script&setup=true&lang=js"
export * from "./quick-filter-species.vue?vue&type=script&setup=true&lang=js"

import "./quick-filter-species.vue?vue&type=style&index=0&id=3b7aa271&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b7aa271"]])

export default __exports__